import { nameByPlatform } from "~/constants/platfroms";
import { X_MENTION } from "~/feature/chart/components/XShareDialog/constants";
import type { IXShareSummary } from "~/feature/chart/components/XShareDialog/types";
import { formatPercentageValue } from "~/utils/formatValue";

const percent = (value: number): string =>
  formatPercentageValue(value * 100, {
    maximumFractionDigits: 1,
    needToAbs: false,
  });

const signed = (value: number): string =>
  value > 0 ? `+${percent(value)}` : percent(value);

const trendEmoji = (value: number): string => {
  if (value > 0) return "📈";
  if (value < 0) return "📉";

  return "➖";
};

const listPlatforms = (names: string[]): string =>
  names.length < 2
    ? names.join("")
    : `${names.slice(0, -1).join(", ")} & ${names[names.length - 1]}`;

export const buildXPostText = ({
  question,
  chance,
  change24h,
  platforms,
  isConsensus,
}: IXShareSummary): string => {
  const value = chance === null ? "N/A" : percent(chance);
  const trend =
    change24h === null
      ? ""
      : `${trendEmoji(change24h)} ${signed(change24h)} in the last 24h`;
  const names = platforms.map((platform) => nameByPlatform[platform]);

  if (isConsensus) {
    return `Prediction markets agree: ${question} ${value} chance — market consensus across ${listPlatforms(names)}${trend && `, ${trend}`}`;
  }

  return `${question} ${value} on ${names[0]}${trend && ` ${trend}`}`;
};

export const withXMention = (text: string, mention: boolean): string =>
  [text.trim(), mention ? `via ${X_MENTION}` : ""].filter(Boolean).join(" ");
